import React from "react";
import PageLayout from "../components/ui/PageLayout";

const BrandAndMarketingPage: React.FC = () => {
  return (
    <PageLayout>
      <h1>Brand & Marketing Page</h1>
    </PageLayout>
  );
};

export default BrandAndMarketingPage;
